import { BfxBlotterOrdersContextMenuItemUnlockState } from "./BfxBlotterOrdersContextMenuItemUnlockState";

import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "./BfxBlotterOrdersContextMenuItem";

import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";

import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class BfxBlotterOrdersContextMenuUnlockItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_UNLOCK,
      "Unlock",
      BfxBlotterOrdersContextMenuUnlockItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuUnlockItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.MenuItem,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  public reset(): void {
    let oldState = this.state;
    this.state = new BfxBlotterOrdersContextMenuItemUnlockState();
    this.state.title = oldState.title;
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
    ) {
      itemState.available = menuState.canUnlock;
    };
  }

  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: BfxBlotterOrdersContextMenuItemUnlockState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!menuState.canUnlock) {
        itemState.enabled = false;
        return;
      }
      if (!item) {
        itemState.enabled = false;
      } else {
        itemState.enabled =
          itemState.enabled && BfxBlotterOrdersContextMenuUnlockItem.checkOrderState(item);
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuUnlockItem.checkLockStateAndType(item, itemState);
        itemState.enabled =
          itemState.enabled &&
          BfxBlotterOrdersContextMenuUnlockItem.checkMembership(item, menuState);
      }
    };
  }

  private static checkMembership(
    item: CubiqTS.OrderDataImpl,
    menuState: BfxBlotterOrdersContextMenuState,
  ): boolean {
    const userType = menuState.activeUser.userTypeId;

    if (userType == CubiqTS.UserType.ADMIN) {
      return true;
    }

    if (userType == CubiqTS.UserType.TRADER) {
      if (menuState.canAcceptUnrestricted) {
        return true;
      }
      if (
        menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString()) ||
        item.deskId == null
      ) {
        return true;
      }
    }
    return false;
  }

  private static checkLockStateAndType(
    item: CubiqTS.OrderDataImpl,
    itemState: BfxBlotterOrdersContextMenuItemUnlockState,
  ): boolean {
    let enabled: boolean = itemState.enabled;
    itemState.lockType = item.lockType;
    if (item.lockType == null) return false;
    switch (item.lockType) {
      case CubiqTS.LockType.FILL_LOCK:
      case CubiqTS.LockType.MODIFY_LOCK:
      case CubiqTS.LockType.SI_LOCK:
        enabled = true;
        break;
      case CubiqTS.LockType.FILL_NOW_LOCK:
        enabled = true;
        break;
      default:
        enabled = false;
        break;
    }
    return enabled;
  }

  private static checkOrderState(item: CubiqTS.OrderDataImpl): boolean {
    let enabled: boolean = true;

    switch (item.orderState) {
      case CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED:
      case CubiqTS.OrderState.ACCEPTANCE_NEEDED:
      case CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED:
        enabled = false;
        break;
      default:
        enabled = true;
        break;
    }

    return enabled;
  }

  public static get state(): any {
    return new BfxBlotterOrdersContextMenuItemUnlockState();
  }
}
